import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as _ from 'underscore';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { PERMISSION } from '../../../analytics-core/interfaces/permission.interface';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import * as jQuery from 'jquery';
@Component({
	selector: 'app-quick-stats',
	styleUrls: ['./quick-stats.component.css'],
	templateUrl: './quick-stats.component.html'
})
export class QuickStatsComponent implements OnInit, WidgetCore, OnDestroy {
	@Input() downloadconfig: any;
	@Input() downloadcsvcolumns: any;
	@Input() columnsconfig: any;
	@Input() iscustomendpoint: any;
	@Input() uniqueoverwriteid: string;

	title: string;
	color: any;
	quickStatsData: any;
	public downloadConfiguration: DownloadConfig;
	public key: string;
	public sectiontitle: string;
	public sectionclass: string;
	public showLoad = true;
	public hasData = true;
	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: true,
		position: 'top',
		scale: 'big',
		theme: 'dark-theme'
	};
	public downloadCSVColumns: any;
	public adInteractionNoSEMTooltip = 'Hovers + Video Plays (IBV Only)';
	public adInteractionSEMTooltip = 'Hovers + Video Plays (IBV Only) + SEM Calls';
	public adInteractionTooltip = '';
	public reloadSubscription;
	public widgetDataSubscription;
	public columns: any;
	public isAudio: boolean = false;
	public isEmail: boolean;
	public isGAM: boolean;
	public clicksToolTip: string;
	public newTabXLSXRequired: boolean = false;
	public isR8: boolean = false;
	public isGam: boolean;
	public isOverview: boolean = false;
	public gamMapAccess: boolean = false;
	public isR1: boolean = false;
	public isDOOHenabled: boolean = false;
	public isDooh: boolean = false;
	public dooh_permission: object = { permission: { flags: ['hasDOOH'] } };
	public isR7Series: boolean;
	public isR104: boolean;

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.isR8 = this.analyticsDataModel.config.version === 'R8' ? true : false;
		this.isDOOHenabled = this.analyticsDataModel.checkComponentForPermission(this.dooh_permission);
		if (this.isR8) {
			this.tooltipOptions['theme'] = 'light custom';
		}
		this.isGam = this.analyticsDataModel.getCurrentPath() === PATHS.GAM;
		this.isOverview = this.analyticsDataModel.getCurrentPath() === PATHS.OVERVIEW;
		this.isDooh = this.analyticsDataModel.getCurrentPath() === PATHS.DOOH;
		this.gamMapAccess = this.analyticsDataModel.setupData.userPermissions['hasGamMapAccess'];
		let partnerConfig = this.analyticsDataModel.config.directoryName.toLowerCase();
		this.isR1 = partnerConfig === 'default-r1' || partnerConfig === 'midco' || partnerConfig === 'hearst-r1';
		this.isR7Series =
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r701' ||
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r7'
				? true
				: false;
		this.isR104 = this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r104' ? true : false;
		if (this.isR104) {
			this.tooltipOptions.theme = 'light r104-theme';
		}
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		if (this.analyticsDataModel.getCurrentPath() === PATHS.RADIO) {
			this.isAudio = true;
		}
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.columns = JSON.parse(decodeURI(this.columnsconfig));
		this.requestData();
		const userPermissions: any[] = this.analyticsDataModel.setupData.permissions;
		if (
			_.indexOf(userPermissions, PERMISSION[PERMISSION.hasSem]) !== -1 &&
			this.analyticsDataModel.getCurrentPath() === PATHS.OVERVIEW
		) {
			this.adInteractionTooltip = this.adInteractionSEMTooltip;
		} else {
			this.adInteractionTooltip = this.adInteractionNoSEMTooltip;
		}
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		if (
			this.downloadConfiguration &&
			this.downloadConfiguration.permission &&
			this.downloadConfiguration?.permission['flags']
		) {
			this.newTabXLSXRequired = !this.downloadConfiguration.permission['flags']
				.map((permission) => {
					return this.analyticsDataModel
						.checkComponentForPermission({ permission: { flags: [permission] } })
						.toString();
				})
				.includes('false');
		}
		this.isEmail = this.analyticsDataModel.getCurrentPath() === PATHS.Email;
		this.isGAM = this.analyticsDataModel.getCurrentPath() === PATHS.GAM;
		this.clicksToolTip = this.isEmail
			? 'Number of clicks within an email \t Click Rate = Clicks/Sends \n\n Please note: Clicks are attributed to the campaign’s deployment date for reporting purposes.'
			: 'Number of user clicks on ads';
		if (this.isR8 && this.isGam && !this.gamMapAccess) {
			jQuery('div#' + this.uniqueoverwriteid).removeClass('analytics-portlet-15p');
			jQuery('div#' + this.uniqueoverwriteid).addClass('analytics-portlet-100p');
			this.sectionclass = this.sectionclass + ' email-quick-stats';
		}
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		if (this.iscustomendpoint == 'true') {
			this.widgetDataSubscription = this.analyticsService
				.processCustomServiceRequest(this.key, null, null, null, null, this.uniqueoverwriteid)
				.subscribe((res: any) => {
					this.showLoad = false;
					if (res.success) {
						this.hasData = true;
						this.processResponseData(res.data);
					} else {
						this.hasData = false;
					}
				});
		} else {
			this.widgetDataSubscription = this.analyticsService
				.processWidgetRequest(this.key, this.columns, null, this.uniqueoverwriteid)
				.subscribe((res: any) => {
					this.showLoad = false;
					if (res.success) {
						this.hasData = true;
						this.processResponseData(res.data);
					} else {
						this.hasData = false;
					}
				});
		}
	}

	downloadCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns,
			null,
			this.newTabXLSXRequired ? this.downloadConfiguration.newTabCsvQueryKey : '',
			this.newTabXLSXRequired ? this.downloadConfiguration.newTabCsvFileName : ''
		);
	}

	processResponseData(response: any): void {
		const impressions = response[0].hasOwnProperty('impressions')
			? UtilityService.isUndefinedOrNull(response[0].impressions)
				? 0
				: response[0].impressions
			: null;
		const engagements = response[0].hasOwnProperty('engagements')
			? UtilityService.isUndefinedOrNull(response[0].engagements)
				? 0
				: response[0].engagements
			: null;
		const adInteractions = response[0].hasOwnProperty('ad_interactions')
			? UtilityService.isUndefinedOrNull(response[0].ad_interactions)
				? 0
				: response[0].ad_interactions
			: null;
		const totalVisits = response[0].hasOwnProperty('total_visits')
			? UtilityService.isUndefinedOrNull(response[0].total_visits)
				? 0
				: response[0].total_visits
			: null;
		const viewThroughs = response[0].hasOwnProperty('view_throughs')
			? UtilityService.isUndefinedOrNull(response[0].view_throughs)
				? 0
				: response[0].view_throughs
			: null;
		const clicks = response[0].hasOwnProperty('clicks')
			? UtilityService.isUndefinedOrNull(response[0].clicks)
				? 0
				: response[0].clicks
			: null;
		const audience = response[0].hasOwnProperty('audience')
			? UtilityService.isUndefinedOrNull(response[0].audience)
				? 0
				: response[0].audience
			: null;
		const opens = response[0].hasOwnProperty('opens')
			? UtilityService.isUndefinedOrNull(response[0].opens)
				? 0
				: response[0].opens
			: null;
		let offlineVisits = response[0].hasOwnProperty('offline_visits')
			? UtilityService.isUndefinedOrNull(response[0].offline_visits)
				? null
				: response[0].offline_visits
			: null;

		// check for permission
		const userPermissions: any[] = this.analyticsDataModel.setupData.permissions;
		if (_.indexOf(userPermissions, PERMISSION[PERMISSION.hasOfflineVisits]) == -1) {
			offlineVisits = null;
		}

		const airedSpots = response[0].hasOwnProperty('aired_spots')
			? UtilityService.isUndefinedOrNull(response[0].aired_spots)
				? 0
				: response[0].aired_spots
			: null;
		const exposures = response[0].hasOwnProperty('exposures')
			? UtilityService.isUndefinedOrNull(response[0].exposures)
				? 0
				: response[0].exposures
			: null;
		const topNetworkAiredSpots = response[0].hasOwnProperty('top_network_aired_spots')
			? UtilityService.isUndefinedOrNull(response[0].top_network_aired_spots)
				? 0
				: response[0].top_network_aired_spots
			: null;
		const zones = response[0].hasOwnProperty('zone_aired_spots')
			? UtilityService.isUndefinedOrNull(response[0].zone_aired_spots)
				? 0
				: response[0].zone_aired_spots
			: null;
		const topNetwork = response[0].hasOwnProperty('top_network')
			? UtilityService.isUndefinedOrNull(response[0].top_network)
				? ''
				: response[0].top_network
			: null;
		const topProgram = response[0].hasOwnProperty('top_program')
			? UtilityService.isUndefinedOrNull(response[0].top_program)
				? ''
				: response[0].top_program
			: null;
		const topProgramAiredSpots = response[0].hasOwnProperty('top_program_aired_spots')
			? UtilityService.isUndefinedOrNull(response[0].top_program_aired_spots)
				? 0
				: response[0].top_program_aired_spots
			: null;

		const engagementPercentage = response[0].hasOwnProperty('engagements_percent')
			? UtilityService.isUndefinedOrNull(response[0].engagements_percent)
				? '-- '
				: parseFloat(response[0].engagements_percent).toFixed(2)
			: null;
		const adInteractionsPercentage = response[0].hasOwnProperty('ad_interactions_percent')
			? UtilityService.isUndefinedOrNull(response[0].ad_interactions_percent)
				? '-- '
				: parseFloat(response[0].ad_interactions_percent).toFixed(2)
			: null;
		const visitsPercentage = response[0].hasOwnProperty('total_visits_percent')
			? UtilityService.isUndefinedOrNull(response[0].total_visits_percent)
				? '-- '
				: parseFloat(response[0].total_visits_percent).toFixed(2)
			: null;
		const viewThroughsPercentage = response[0].hasOwnProperty('view_throughs_percent')
			? UtilityService.isUndefinedOrNull(response[0].view_throughs_percent)
				? '-- '
				: parseFloat(response[0].view_throughs_percent).toFixed(2)
			: null;
		const clicksPercentage = response[0].hasOwnProperty('clicks_percent')
			? UtilityService.isUndefinedOrNull(response[0].clicks_percent)
				? '-- '
				: parseFloat(response[0].clicks_percent).toFixed(2)
			: null;
		const opensPercentage = response[0].hasOwnProperty('opens_percent')
			? UtilityService.isUndefinedOrNull(response[0].opens_percent)
				? '-- '
				: parseFloat(response[0].opens_percent).toFixed(2)
			: null;
		const adplays = response[0].hasOwnProperty('adplays')
			? UtilityService.isUndefinedOrNull(response[0].adplays)
				? 0
				: response[0].adplays
			: null;

		this.quickStatsData = {
			impressions: impressions,
			engagements: engagements,
			adInteractions: adInteractions,
			totalVisits: totalVisits,
			viewThroughs: viewThroughs,
			audience: audience,
			opens: opens,
			clicks: clicks,
			offlineVisits: offlineVisits,
			airedSpots: airedSpots,
			exposures: exposures,
			topNetworkAiredSpots: topNetworkAiredSpots,
			zones: zones,
			topNetwork: topNetwork,
			topProgram: topProgram,
			topProgramAiredSpots: topProgramAiredSpots,
			engagementPercentage: engagementPercentage,
			adInteractionsPercentage: adInteractionsPercentage,
			visitsPercentage: visitsPercentage,
			viewThroughsPercentage: viewThroughsPercentage,
			clicksPercentage: clicksPercentage,
			opensPercentage: opensPercentage,
			adplays: adplays
		};
	}
}
